"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersionDisplay = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var VersionDisplay = /** @class */ (function (_super) {
    __extends(VersionDisplay, _super);
    function VersionDisplay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VersionDisplay.prototype.render = function () {
        var displayAppInfoStringified = JSON.stringify(process.env.REACT_APP_DISPLAY_APP_INFORMATION_ON_SCREEN);
        var displayAppInformationOnScreen = displayAppInfoStringified === JSON.stringify("true") || displayAppInfoStringified === JSON.stringify("True");
        return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: displayAppInformationOnScreen &&
                (0, jsx_runtime_1.jsx)("div", { id: "versionDisplayContainer", children: (0, jsx_runtime_1.jsxs)("div", { children: [process.env.REACT_APP_APPLICATION_NAME ? process.env.REACT_APP_APPLICATION_NAME : "-", " : ", (0, jsx_runtime_1.jsx)("b", { children: process.env.REACT_APP_APPLICATION_VERSION ? process.env.REACT_APP_APPLICATION_VERSION : "-" })] }) }) }));
    };
    return VersionDisplay;
}(React.Component));
exports.VersionDisplay = VersionDisplay;
//# sourceMappingURL=VersionDisplay.js.map